import React,{useState,useEffect,useContext,createContext} from 'react'
import {Link,useParams,useNavigate} from 'react-router-dom'
import axios from 'axios'
import {Form,Button,Container,Card,Alert,Table,Modal,Navbar,NavDropdown,Nav,Row,Col,Accordion} from 'react-bootstrap'
import { usePDF } from "react-to-pdf";

export default function Badge() {

    const { exURL,barcode} = useParams()
    const [isLoading,setIsLoading]=useState(false)
    const [html,setHtml]=useState('')
    const [error,setError]=useState(0)
    const [email,setEmail]=useState({})

    const { toPDF, targetRef } = usePDF({
        filename: exURL+'.pdf',
        options: {
            html2canvas: { useCORS: true, scale: 2 },
        },
    });

    async function handlePDF() {
        setIsLoading(true)
        await waitForImages(targetRef.current);
        toPDF();
        
    }

  const waitForImages = (element) => {
    if (!element) return Promise.resolve();
    const images = element.querySelectorAll("img");
    return Promise.all(
      Array.from(images).map((img) => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // still resolve on error
        });
      })
    );
  }; 

    useEffect(()=>{
        loadData()
    },[])

    const loadData=()=>{
    setIsLoading(true)
      axios.get(process.env.REACT_APP_API_SERVER+'/badge/'+barcode,{
        // headers: {
        //     'Authorization': 'Bearer '+sessionStorage.getItem("token")
        //     }            
        })
        .then(xres=>{
            if (xres.data.err==0){
               // console.log(xres.data.badge)

                const url='https://services-helexpo.gr/visitorsbadges/'
                const formData=new FormData()

                formData.append('ExCode',xres.data.badge.ExCode)
                formData.append('Token',process.env.REACT_APP_PHP_API_KEY)
                    axios.post(url,formData,{})
                    .then(res=>{
                        //console.log(res.data)
                        //alert(xres.data.badge.Email)
                        setEmail(xres.data.badge.Email)
                        let xhtml=res.data.replace('{{Name}}',xres.data.badge.PName).replace('{{Company}}',xres.data.badge.Company)
                        xhtml=xhtml.replace('{{QRCODE}}',`https://services-helexpo.gr/visitorsbadges/qrcode.php?BarCode=${xres.data.badge.BarCode}`)
                        setHtml(xhtml)
                        setIsLoading(false)
                    }).catch(err=>{
                        alert('An error has occured')
                        setIsLoading(false)
                    })

            }else{
                setError(1)
                setIsLoading(false)
                alert('Error loading data')            
            }

        }).catch(err=>{
            setError(1)
            setIsLoading(false)
            alert('Error loading data')
        })  

    }

    const unsubscribe=()=>{
        if (window.confirm('Are you sure you want to unsubscribe? / Είστε σίγουροι ότι θέλετε να απεγγραφείτε;')){
                axios.post(process.env.REACT_APP_API_SERVER+'/unsubscribe',{Email:email})
                .then(res=>{

                // if (res.data.result.result.affectedRows==0){
                //   alert('Email not found in our database//Το email δεν βρέθηκε στην βάση δεδομένων μας')
                //   setUnsubscribed(true)
                //   setUnsubscribedEmail(email)
                // }else{
                    if (res.data.err==1){
                        alert('Email not found in our database//Το email δεν βρέθηκε στην βάση δεδομένων μας')
                    }else{
                        alert('You have been unsubscribed successfully//Έχετε απεγγραφεί με επιτυχία')
                    }

                //}

                }).catch(err=>{
                alert('Error Occurred')
                })
        }
    }

    return (
        <Container fluid>

        <Alert variant='success'>

            


            <Row style={{height:'40px',marginBottom:'10px'}}>
                <Col md={10}>
                    <Button disabled={isLoading} variant="success" onClick={handlePDF}>{'Download as PDF'}</Button>
                    &nbsp;&nbsp;      
                </Col>
                <Col md={2}>
                    <Button variant="danger" onClick={()=>unsubscribe()}>Unsubscribe // Απεγγραφή </Button>
                </Col>
            </Row> 


        </Alert>
        <br/>

        <div
            ref={targetRef}
            dangerouslySetInnerHTML={{ __html: html }}
            style={{

            //transformOrigin: "top left",
            width: "850px",
            height: "auto",

            //border: "1px solid green"
            }}
        />

        </Container>
    )
}
